export default __webpack_public_path__ + "static/media/icons8-notification-96.d6afd9a7.svg";